import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-request-failed-help',
    templateUrl: './request-failed-help.component.html',
    standalone: false
})
export class RequestFailedHelpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }

}
